import { BedDetailContent } from '@/features/beds/components/BedDetailContent'
import { useGetBed } from '@/features/beds/hooks/useBed'
import { useGetPatientItems } from '@/features/patients/hooks/usePatient'
import { Activity } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function ScanBedContent({ departmentId, bedId }: { departmentId: string; bedId: string }) {
  const { t } = useTranslation()
  const { data: bed, isLoading: isLoadingBed } = useGetBed(departmentId, bedId!)
  const { data: patientItems, isLoading: isLoadingPatientItems } = useGetPatientItems(bed?.patientId!, !!bed?.patientId)

  if (isLoadingBed || isLoadingPatientItems) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background p-6 text-center">
        <p className="mt-1 text-sm text-muted-foreground">{t('common.loading')}</p>
      </div>
    )
  }

  if (!bed) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background p-6 text-center">
        <Activity className="size-12 text-muted-foreground/30" />
        <h1 className="mt-4 text-lg font-semibold text-foreground">{t('bed.detail.notFoundBed')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t('bed.detail.notFoundBed')} ID: {bedId}
        </p>
        <a href="/" className="mt-4 text-sm text-primary hover:underline">
          {t('common.backToHome')}
        </a>
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-lg p-4">
      <BedDetailContent bed={bed} patientItems={patientItems}></BedDetailContent>
    </div>
  )
}
